import { HomeView } from '../views';
export default HomeView;
